"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLineSizePricingBandForLineSizeCents = resolveLineSizePricingBandForLineSizeCents;
exports.cashAndPayoffToLineSizeCentsForPricingBands = cashAndPayoffToLineSizeCentsForPricingBands;
const math_1 = require("./math");
function getPricingBandBoundsCents(band) {
    return {
        minLineSizeCents: (0, math_1.roundDecimalProduct)(band.minLineSize, 100),
        maxLineSizeCents: (0, math_1.roundDecimalProduct)(band.maxLineSize, 100),
    };
}
function bandContainsLineSizeCents(band, lineSizeCents) {
    const { minLineSizeCents, maxLineSizeCents } = getPricingBandBoundsCents(band);
    return lineSizeCents >= minLineSizeCents && lineSizeCents <= maxLineSizeCents;
}
function resolveLineSizePricingBandForLineSizeCents(lineSizePricingBands, lineSizeCents) {
    return lineSizePricingBands?.find((band) => bandContainsLineSizeCents(band, lineSizeCents)) ?? null;
}
/**
 * Resolve the line size for a cash + payoff amount using the recording-tax policy of the
 * applicable line-size band. Each band is solved independently and the candidate that falls
 * inside that band's inclusive range wins; this avoids applying the offer-level recording fee
 * to a band marked recordingTaxFree.
 */
function cashAndPayoffToLineSizeCentsForPricingBands(cashAndPayoffCents, feeDecimal, recordingTaxFixedCents, recordingTaxVariableDecimal, lineSizePricingBands) {
    for (const band of lineSizePricingBands ?? []) {
        const candidate = (0, math_1.cashAndPayoffToLineSizeCents)(cashAndPayoffCents, feeDecimal, band.recordingTaxFree ? 0 : recordingTaxFixedCents, band.recordingTaxFree ? 0 : recordingTaxVariableDecimal);
        const { minLineSizeCents, maxLineSizeCents } = getPricingBandBoundsCents(band);
        if (candidate >= minLineSizeCents && candidate <= maxLineSizeCents) {
            return candidate;
        }
    }
    const fallback = (0, math_1.cashAndPayoffToLineSizeCents)(cashAndPayoffCents, feeDecimal, recordingTaxFixedCents, recordingTaxVariableDecimal);
    return fallback;
}
